// extracted by mini-css-extract-plugin
export var closeButton = "_1s-3";
export var header = "_1s-0";
export var link = "_1s-1";
export var retryButton = "_1s-2";